module.exports = __webpack_public_path__ + "media/Video 7.7cfae55e.mp4";